const REPUTATION_PLUS_ACTIONS = [
  'reputation_plus:viewRelease',
  'reputation_plus:viewPage',
];

module.exports = {
  REPUTATION_PLUS_ACTIONS,
};
